@use "../../../sass/variables/colors";
@use "../../../sass/variables/dimensions";

.ux-modal-footer {
  align-items: stretch;
  border-top: 1px solid colors.$color-gray-background;
  display: flex;
  flex: 0 0 auto;
  flex-direction: column;
  justify-content: space-between;
  padding: dimensions.$dim-30;

  ux-button,
  & > .ux-button {
    flex: 1 0 auto;
  }

  &__spacer {
    flex: 0 0 dimensions.$dim-15;
  }

  @media (width >= 569px) {
    flex-flow: row-reverse nowrap;

    ux-button,
    & > .ux-button {
      flex: 1 1 50%;
    }

    &__spacer {
      flex: 0 0 dimensions.$dim-30;
    }
  }
}
